import * as React from 'react';
import styled from 'styled-components';
import { Divider, IconRow, InfoColumn, StylelessButton, Title } from './_styles';
import { changeProperty } from '@src/actions';
import { Alignment } from '@src/interfaces/nodes';
import { Colors } from '@src/styles';
import { getSelectedNode } from '@src/utils';
const HorizontalAlignmentWrapper = styled.div `
  cursor: pointer;
  display: grid;
  grid-template-columns: 6px 6px 6px;
  grid-template-rows: 18px;
  margin-right: 8px;
`;
const VerticalAlignmentWrapper = styled.div `
  display: grid;
  grid-template-columns: 18px;
  grid-template-rows: 6px 6px 6px;
  margin-right: 8px;
`;
const AlignmentItem = styled.div `
  background: ${Colors.grey200};
`;
const AlignmentItemSelected = styled(AlignmentItem) `
  background: ${({ selected }) => (selected ? Colors.accent : Colors.grey500)};
`;
const changeHorizontalAlignment = (alignment) => () => {
    changeProperty('horizontalAlign', alignment);
};
const changeVerticalAlignment = (alignment) => () => {
    changeProperty('verticalAlign', alignment);
};
const AlignmentMutators = () => {
    const component = getSelectedNode();
    return (React.createElement(React.Fragment, null,
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Horizontal"),
            React.createElement(IconRow, null,
                React.createElement(StylelessButton, { title: "Left", onClick: changeHorizontalAlignment(Alignment.start) },
                    React.createElement(HorizontalAlignmentWrapper, null,
                        React.createElement(AlignmentItemSelected, { selected: component.horizontalAlign === Alignment.start }),
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItem, null))),
                React.createElement(StylelessButton, { title: "Middle", onClick: changeHorizontalAlignment(Alignment.center) },
                    React.createElement(HorizontalAlignmentWrapper, null,
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItemSelected, { selected: component.horizontalAlign === Alignment.center }),
                        React.createElement(AlignmentItem, null))),
                React.createElement(StylelessButton, { title: "Right", onClick: changeHorizontalAlignment(Alignment.end) },
                    React.createElement(HorizontalAlignmentWrapper, null,
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItemSelected, { selected: component.horizontalAlign === Alignment.end }))))),
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Vertical"),
            React.createElement(IconRow, null,
                React.createElement(StylelessButton, { title: "Top", onClick: changeVerticalAlignment(Alignment.start) },
                    React.createElement(VerticalAlignmentWrapper, null,
                        React.createElement(AlignmentItemSelected, { selected: component.verticalAlign === Alignment.start }),
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItem, null))),
                React.createElement(StylelessButton, { title: "Middle", onClick: changeVerticalAlignment(Alignment.center) },
                    React.createElement(VerticalAlignmentWrapper, null,
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItemSelected, { selected: component.verticalAlign === Alignment.center }),
                        React.createElement(AlignmentItem, null))),
                React.createElement(StylelessButton, { title: "Bottom", onClick: changeVerticalAlignment(Alignment.end) },
                    React.createElement(VerticalAlignmentWrapper, null,
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItem, null),
                        React.createElement(AlignmentItemSelected, { selected: component.verticalAlign === Alignment.end })))))));
};
export default AlignmentMutators;
